<template>
  <div>
    <div style="margin: 20px ;font-size: 18px; color: #1890ff">
      <span>报备人:</span>
      <a-input style="margin: 0px 10px;width: 100px" ref="userNameInput" v-model="report" type="text"></a-input>
      <span>公司名称:</span>
      <a-input style="margin: 0px 10px;width: 200px" v-model="company" type="text"></a-input>
      <span>最后修改时间:</span>
      <a-range-picker style="margin: 0px 10px" :default-value="[moment(new Date(), 'YYYY-MM-DD').add(-20,'days'), moment(new Date(), 'YYYY-MM-DD')]" @change="onChange"/>
      <a-button
        type="primary"
        icon="search"
        style="width: 90px; margin-left: 20px" @click="onselect"
      >查找</a-button>
      <a-button
        type="primary"
        style="width: 90px; margin-left: 150px" @click="insertout"
      >新增</a-button>
    </div>
    <a-table
      :loading="loading"
      :columns="reportColumns"
      :dataSource="reportList"
      :rowKey="(record, index)=>{return index}"
      :pagination="pagination"
      :customRow="clickRow"
      :scroll="{ y: tableHeight }"
      size="small"
    >
    </a-table>
    <a-modal :width="400" v-model="visible" title="业务员修改" centered @ok="visible = false" >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          取消
        </a-button>
        <a-button key="submit" type="primary" @click="salesmanupdata">
          修改
        </a-button>
      </template>
      <a-row class="row" type="flex" justify="center">
        <a-col :span="24">
          <span>业务员:</span>
          <!--        <a-input style="margin: 0px 10px;width: 150px" v-model="salesman" type="text"></a-input>-->
          <a-select
            show-search
            :value="this.currentData.salesman"
            style="width: 290px"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            @search="salesdeptSearch"
            @change="salesmanchange"
          >
            <a-select-option v-for="d in salesdeptdata" :key="d.value">
              {{ d.text+d.companyname }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="24">
          <span>部门:</span>
          <a-input style="margin: 10px 14px;width: 290px" v-model="currentData.dept" type="text" :disabled="true"></a-input>
        </a-col>
      </a-row>
    </a-modal>
    <a-modal :width="700" v-model="insertvisible" title="报备信息新增" centered @ok="insertvisible = false" >

      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          取消
        </a-button>
        <a-button key="submit" type="primary" @click="oninsert">
          新增
        </a-button>
      </template>
      <div>
      <a-row class="row" type="flex" justify="center">
        <a-col :span="3">
          <span style="color: red">*</span>报备人:
        </a-col>
        <a-col :span="5">
          <a-select
            show-search
            :value="insertData.reporter"
            style="width: 100px"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            :dropdownMatchSelectWidth="false"
            :dropdownStyle="{ width: '300px' }"
            @search="salesdeptSearch"
            @change="reporterchange"
          >
            <a-select-option v-for="d in salesdeptdata" :key="d.value">
              {{ d.text + d.companyname }}
            </a-select-option>
          </a-select>
<!--          <a-input style="width: 150px" v-model="insertData.reporter" type="text"></a-input>-->
        </a-col>
        <a-col :span="3">
          <span style="color: red">*</span>报备区域:
        </a-col>
        <a-col :span="9">
          <a-select :default-value="areaList[0].id" style="width: 150px" @change="areaChange">
            <a-select-option v-for="(i, index) in areaList" :key="index" :value="i.id">
              {{ i.name }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
        <a-row class="row" type="flex" justify="center">
          <a-col :span="3">
            <span style="color: red">*</span>接单业务员:
          </a-col>
          <a-col :span="5">
<!--            <a-input style="width: 150px" v-model="insertData.salesman" type="text" @change="salesdept"></a-input>-->
            <a-select
              show-search
              :value="insertData.salesman"
              style="width: 100px"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              :dropdownMatchSelectWidth="false"
              :dropdownStyle="{ width: '300px' }"
              @search="salesdeptSearch"
              @change="salesdeptchange"
            >
              <a-select-option  v-for="d in salesdeptdata" :key="d.value">
                {{ d.text+d.companyname }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="3">
            <span style="color: red">*</span>部门:
          </a-col>
          <a-col :span="9">
            <a-input style="width: 232px" v-model="insertData.dept" type="text" :disabled="true"></a-input>
          </a-col>
        </a-row>
        <a-row class="row" type="flex" justify="center">
          <a-col :span="3">
            <span style="color: red">*</span>客户全称:
          </a-col>
          <a-col :span="17">
            <a-input style="width: 380px" v-model="insertData.customerFullName" type="text"></a-input>
            <a-button @click="checkreport" style="left: 5px">查重</a-button>
          </a-col>
        </a-row>
        <a-row class="row" type="flex" justify="center">
          <a-col :span="3">
            <span style="color: red">*</span>地址:
          </a-col>
          <a-col :span="17">
            <a-input style="width: 450px" v-model="insertData.address" type="text"></a-input>
          </a-col>
        </a-row>
        <a-row class="row" type="flex" justify="center">
          <a-col :span="3">决策人:</a-col>
          <a-col :span="8">
            <a-input style="width: 150px" v-model="insertData.contactPerson" type="text"></a-input>
          </a-col>
          <a-col :span="3">手机号码:</a-col>
          <a-col :span="6">
            <a-input style="width: 150px" v-model="insertData.mobile" type="text"></a-input>
          </a-col>
        </a-row>
        <a-row class="row" type="flex" justify="center">
          <a-col :span="3"><span style="color: red">*</span>行业:</a-col>
          <a-col :span="8">
            <a-select style="width: 150px" @change="industryChange">
              <a-select-option v-for="(i, index) in industryList" :key="index" :value="i.name">
                {{i.name}}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="3">职务:</a-col>
          <a-col :span="6">
            <a-input style="width: 150px" v-model="insertData.professionalTitle" type="text"></a-input>
          </a-col>
        </a-row>
      </div>
      <a-row class="row" type="flex" justify="center">
        <a-col :span="3">现有品牌:</a-col>
        <a-col :span="17">
          <a-input style="width: 450px" v-model="insertData.brand" type="text"></a-input>
        </a-col>
      </a-row>
      <a-row class="row" type="flex" justify="center">
        <a-col :span="3">空压机情况:</a-col>
        <a-col :span="17">
          <a-input style="width: 450px" v-model="insertData.infoNote" type="text"></a-input>
        </a-col>
      </a-row>
      <a-row class="row" type="flex" justify="center">
        <a-col :span="3">竞争对手:</a-col>
        <a-col :span="17">
          <a-input style="width: 450px" v-model="insertData.competitor" type="text"></a-input>
        </a-col>
      </a-row>
      <a-row class="row" type="flex" justify="center">
        <a-col :span="3">项目困难:</a-col>
        <a-col :span="17">
          <a-input style="width: 450px" v-model="insertData.hard" type="text"></a-input>
        </a-col>
      </a-row>
      <a-row class="row" type="flex" justify="center">
        <a-col :span="3">备注:</a-col>
        <a-col :span="17">
          <a-input style="width: 450px"  v-model="insertData.remark" type="text"></a-input>
        </a-col>
      </a-row>
    </a-modal>
    </div>
</template>

<script>
import { reportColumns } from './data'
import crmApi from '../../api/crmreport'
import moment from 'moment'

export default {
  name: 'index',
  mounted () {
    this.$refs.userNameInput.focus()
  },
  data () {
    return {
      report: '',
      company: '',
      salesman: '',
      startDatetime: '',
      visible: false,
      insertvisible: false,
      endDatetime: '',
      date: '',
      reportColumns,
      reportList: [{}],
      areaList: [{}],
      industryList: [{}],
      areadata: '',
      industrydata: '',
      inserttime: '',
      loading: false,
      tableHeight: innerHeight - 168,
      currentData: {
      },
      insertData: {
        reporter: '',
        dept: '',
        salesman: '',
        areaId: '',
        customerFullName: '',
        address: '',
        industry: '',
        contactPerson: '',
        mobile: '',
        professionalTitle: '',
        brand: '',
        infoNote: '',
        competitor: '',
        hard: '',
        remark: '',
        createdAt: '',
        updatedAt: ''
      },
      salesdeptdata: [],
      salesdeptvalue: '',
      pagination: {
        defaultPageSize: 100,
        defaultCurrent: 1
      }
    }
  },
  created () {
    this.getlist().then(() => {
      this.startDatetime = moment(new Date()).add(-20, 'days').format('YYYY-MM-DD') + ' 00:00:00'
      this.endDatetime = moment(new Date()).format('YYYY-MM-DD') + ' 23:59:59'
      this.getreportlist(this.report.trim(), this.company.trim(), this.startDatetime, this.endDatetime, this.token)
      this.loading = false
    }).catch(() => {
      this.$message.error('请求失败')
      this.loading = false
    })
  },
  methods: {
    moment,
    clickRow (record, index) {
      return {
        on: {
          click: () => {
            this.currentData = record
            this.visible = true
            this.salesdeptdata = []
            // this.salesman = this.currentData.salesman
          }
        }
      }
    },
    onChange (date, dateString) {
      this.startDatetime = dateString[0] + ' 00:00:00'
      this.endDatetime = dateString[1] + ' 23:59:59'
    },
    onselect () {
      this.getreportlist(this.report.trim(), this.company.trim(), this.startDatetime, this.endDatetime)
    },
    insertout () {
      this.insertvisible = true
      this.insertData.areaId = this.areaList[0].id
      this.insertData.industry = ''
      this.insertData.reporter = ''
      this.insertData.dept = ''
      this.insertData.salesman = ''
      this.insertData.customerFullName = ''
      this.insertData.address = ''
      this.insertData.contactPerson = ''
      this.insertData.mobile = ''
      this.insertData.professionalTitle = ''
      this.insertData.brand = ''
      this.insertData.infoNote = ''
      this.insertData.competitor = ''
      this.insertData.hard = ''
      this.insertData.remark = ''
      this.salesdeptdata = []
    },
    oninsert () {
      if (this.insertData.reporter === '') {
        this.$message.warning('请输入报备人！', 1)
        return
      }
      if (this.insertData.dept === '') {
        this.$message.warning('请输入部门！', 1)
        return
      }
      if (this.insertData.salesman === '') {
        this.$message.warning('请输入接单业务员！', 1)
        return
      }
      if (this.insertData.customerFullName === '') {
        this.$message.warning('请输入客户全称！', 1)
        return
      }
      if (this.insertData.address === '') {
        this.$message.warning('请输入地址！', 1)
        return
      }
      if (this.insertData.industry === '') {
        this.$message.warning('请输入行业！', 1)
        return
      }
      this.checkreport().then(res => {
        if (res) {
          this.insertData.createdAt = moment(new Date()).format('YYYY-MM-DD HH:mm')
          this.insertData.updatedAt = moment(new Date()).format('YYYY-MM-DD HH:mm')
          crmApi.datainsert(this.insertData).then((data) => {
            if (data > 0) {
              this.$message.success('新增成功！', 1)
            } else {
              this.$message.error('新增失败！', 1)
            }
            this.insertData = ''
            this.insertvisible = false
            this.loading = false
          }).catch(({ message }) => {
            this.$message.error(message)
          })
        }
      })
    },
    handleCancel (e) {
      this.visible = false
      this.insertvisible = false
    },
    areaChange (value) {
      this.insertData.areaId = value
    },
    reporterchange (value) {
      this.salesdeptdata.forEach(dept => {
        if (dept.value === value) {
          this.insertData.reporter = dept.text
        }
      })
    },
    salesdeptchange (value) {
      this.salesdeptdata.forEach(dept => {
        if (dept.value === value) {
          this.insertData.dept = dept.companyname
          this.insertData.salesman = dept.text
        }
      })
    },
    salesmanchange (value) {
      this.salesdeptdata.forEach(dept => {
        if (dept.value === value) {
          this.currentData.dept = dept.companyname
          this.currentData.salesman = dept.text
        }
      })
    },
    salesdeptSearch (value) {
      if (value === '') {
        this.salesdeptdata = []
        return
      }
      crmApi.salesdeptList(value).then((data) => {
        this.salesdeptdata = []
        data.forEach(r => {
          this.salesdeptdata.push({
            value: r.id,
            text: r.name,
            companyname: r.companyname,
            userpermission: r.userpermission
          })
        })
        this.loading = false
      }).catch(({ message }) => {
        this.$message.error(message, 1)
      })
    },
    checkreport () {
      return crmApi.checkreport('-1', this.insertData.customerFullName).then((data) => {
        this.loading = false
        if (data) {
          this.$message.success('客户未报备', 1)
          return true
        } else {
          this.$message.error('客户已报备', 1)
          return false
        }
      })
    },
    industryChange (value) {
      this.insertData.industry = value
    },
    getreportlist (report, company, startDatetime, endDatetime) {
      this.loading = true
      crmApi.crmreport(report, company, startDatetime, endDatetime).then((data) => {
        this.reportList = data
        this.loading = false
      }).catch(({ message }) => {
        this.$message.error(message, 1)
      })
    },
    async getlist () {
      this.loading = true
      this.areaList = await crmApi.arealist()
      this.industryList = await crmApi.industrylist()
      this.loading = false
    },
    salesmanupdata (e) {
      this.loading = true
      crmApi.salesmanupdata(this.currentData, this.currentData.salesman, moment(new Date()).format('YYYY-MM-DD HH:mm')).then((data) => {
        if (this.currentData.id === data) {
          // this.currentData = this.salesman
          this.$message.success('更新成功！')
          this.visible = false
          this.onselect()
        } else {
          this.$message.error('更新失败')
        }
        this.loading = false
      }).catch(({ message }) => {
        this.$message.error(message, 1)
      })
    }
  }
}
</script>

<style scoped>
.row {
  margin-top: 5px;
}
</style>
